<script lang="ts" setup>
import {computed, defineAsyncComponent, provide} from "vue";

import NoChatSelected from "@src/components/states/empty-states/NoChatSelected.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import HeaderArea from "@src/components/views/HomeView/MainArea/HeaderArea/HeaderArea.vue";
import ChatArea from "@src/components/views/HomeView/MainArea/ChatArea/ChatArea.vue";
import FooterArea from "@src/components/views/HomeView/MainArea/FooterArea/FooterArea.vue";
import {useMessageStore} from "@src/stores/messages";
import FadeTransition from "@src/components/ui/transitions/FadeTransition.vue";
import useStore from "@src/stores/store";

const DetailsPane = defineAsyncComponent(() => import("@src/components/views/HomeView/MainArea/DetailsPane/DetailsPane.vue"));
const MediaPane = defineAsyncComponent(() => import("@src/components/views/HomeView/MainArea/DetailsPane/MediaPane.vue"));
const ContactPane = defineAsyncComponent(() => import("@src/components/views/HomeView/MainArea/DetailsPane/ContactPane.vue"));

const sessionStore = useChatSessionStore();
const isEmpty = computed(() => {
    return sessionStore.selectedSession === undefined
})

const store = useStore()

const messageStore = useMessageStore()

const activeSession = sessionStore.selectedSession
// provide the active conversation to all children.
provide("activeConversation", activeSession);
</script>

<template>
    <!--  <Spinner v-if="" />-->
    <FadeTransition mode="out-in" name="fade">
        <div
            v-if="!isEmpty"
            class="h-full flex scrollbar-hidden"
        >
            <div :class="['h-full flex flex-col scrollbar-hidden w-full',
                  store.details || sessionStore.openMediaPane || sessionStore.showContactPane ? 'hidden xl:flex' : ''
                  ]">
                <HeaderArea
                />
                <ChatArea
                />
                <FooterArea/>
            </div>

            <DetailsPane v-if="store.details === true"/>
            <MediaPane v-if="sessionStore.openMediaPane === true"/>
            <ContactPane v-if="sessionStore.showContactPane === true"
                         :contact-id="sessionStore.selectedSession?.costumer?.id"/>
        </div>

        <NoChatSelected v-else/>
    </FadeTransition>
</template>
